import React from "react";
import { Link, navigate } from "gatsby";
import Img_close from "../images/icons/close.svg";
import { Button, InputNumber, Select, Pagination, Empty } from "antd";
import { useAuth0 } from "@auth0/auth0-react";
import { isLoggedIn } from "../services/Auth";
import $ from "jquery";
import { saveState } from "../state/utils/localStorage";
import posthog from 'posthog-js';



export default function Reward({
  props,
  isLogin,
  userInfomration,
  rewards,
  rewards_item_location,
  rewards_category,
  excludedCategoryIds = [],
  loginUrl,
  redemptionUrl,
  langData,
  currentPage,
  minPoint,
  maxPoint,
  currentLocation,
  currentCategory,
  setCurrentPage,
  setMinPoint,
  setMaxPoint,
  setCurrentLocation,
  setCurrentCategory,
  onChangeRange,
  langKey,
}) {
  const special_promotion = [
    { id: 72826, slashed_price: 15000 },
    { id: 15566, slashed_price: 7500 },
    { id: 15564, slashed_price: 11000 },
    { id: 15562, slashed_price: 32000 },
    { id: 15573, slashed_price: 2200 },
    { id: 104458, slashed_price: 11000 },
    { id: 112451, slashed_price: 25711 },
    { id: 118956, slashed_price: 17592 },
    { id: 112452, slashed_price: 19416 },
    { id: 112453, slashed_price: 41136 },
  ];

  const filteredCategories = rewards_category.filter(
    (cat) => !excludedCategoryIds.includes(cat.categoryId ?? cat.category_id)
  );

  const filteredRewardsData = rewards.data?.filter(
    (item) => !excludedCategoryIds.includes(item.categoryId ?? item.category_id)
  );

  const { Option } = Select;

  const { loginWithRedirect, isAuthenticated } = useAuth0();
  const isAuth0Enabled = process.env.GATSBY_ENABLE_AUTH0 === "true";

  const getMemberData = (isLogin, userInfo) => ({
    MemberPoints: isLogin && userInfo?.rewardsInfo ? userInfo.rewardsInfo.points || 0 : 0,
    MemberLevel: isLogin && userInfo?.rewardsInfo ? userInfo.rewardsInfo.level || "" : "",
  });


  const filterMobile = () => {
    //triger posthog
    posthog.capture('rewards_filter_drawer_opened', {
      ...getMemberData(isLogin, userInfomration),
    });
    $(".sidebar").toggle();
  };

  const onChangeMinPoint = (value) => {
    if (value == null) {
      setMinPoint("");
    } else {

      setMinPoint(value);
    }
  };

  const onChangeMaxPoint = (value) => {
    if (value == null) {
      setMaxPoint("");
    } else {
      setMaxPoint(value);
    }
  };

  const onChangeCategory = (value) => {
    setCurrentPage("1");
    setCurrentCategory(value);

    const integerValue = Number(value);
    const itemCategory = rewards_category.find(cat => cat.categoryId === integerValue);
    //triger posthog
    posthog.capture('rewards_filter_by_category', {
      Category: itemCategory?.name,
      ...getMemberData(isLogin, userInfomration),
    });

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  const onChangeLocation = (value) => {
    setCurrentPage("1");
    setCurrentLocation(value);

    const itemLocations = rewards_item_location.find(cat => cat.code === value);
    //triger posthog
    posthog.capture('rewards_filter_by_location', {
      Location: itemLocations?.name,
      ...getMemberData(isLogin, userInfomration),
    });

    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  const filterTrigerPoint = (isDevice) => {

    if (isDevice === "mobile") {
      filterMobile();
    }
    onChangeRange();

    if (minPoint && maxPoint) {
      posthog.capture('rewards_filter_by_point', {
        MinPoint: Number(minPoint),
        MaxPoint: Number(maxPoint),
        ...getMemberData(isLogin, userInfomration),
      });
    }
    else if (maxPoint) {
      posthog.capture('rewards_filter_by_point', {
        MaxPoint: Number(maxPoint),
        ...getMemberData(isLogin, userInfomration),
      });
    } else if (minPoint) {
      posthog.capture('rewards_filter_by_point', {
        MinPoint: Number(minPoint),
        ...getMemberData(isLogin, userInfomration),
      });
    }
  };

  const onChangePages = (page, pageSize) => {
    setCurrentPage(page);
    //triger posthog
    posthog.capture('rewards_page_pagination_clicked', {
      Page: page,
      ...getMemberData(isLogin, userInfomration),
    });
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  };

  const navigateToRedemptionUrl = (id, items) => {

    const itemCategory = rewards_category.find(cat => cat.categoryId === items?.categoryId);
    const itemLocations = rewards_item_location.filter(item => items?.property.includes(item.code)).map(item => item.name).join(',');

    //triger posthog
    posthog.capture('rewards_redeem_item_clicked', {
      ItemName: items.name,
      ItemLocation: itemLocations,
      ItemCategory: itemCategory?.name,
      ...getMemberData(isLogin, userInfomration),
    });

    if (isAuthenticated) {
      window.location.href =
        langKey === "en"
          ? `/member/redemption?id=${id}`
          : `/${langKey}/member/redemption?id=${id}`;
    } else {
      const href =
        langKey === "en"
          ? `/member/redemption?id=${id}`
          : `/${langKey}/member/redemption?id=${id}`;
      saveState("redirectUrl", href);
      loginWithRedirect({
        authorizationParams: {
          ui_locales: langKey === "zh" ? "zh-CN" : langKey,
          redirect_uri:
            langKey === "en"
              ? `${window.location.origin}/callback`
              : `${window.location.origin}/${langKey}/callback`,
        },
        appState: {
          target: "redirectUrl",
        },
      });
    }
  };

  const loginwithoutAuth0 = (items) => {

    const itemCategory = rewards_category.find(cat => cat.categoryId === items?.categoryId);
    const itemLocations = rewards_item_location.filter(item => items?.property.includes(item.code)).map(item => item.name).join(',');

    //triger posthog
    posthog.capture('rewards_redeem_item_clicked', {
      ItemName: items.name,
      ItemLocation: itemLocations,
      ItemCategory: itemCategory?.name,
      ...getMemberData(isLogin, userInfomration),
    });

    if (isLoggedIn()) {
      window.location.href = `${redemptionUrl}/${item.id}`
    } else {
      window.location.href = `${loginUrl}?is_redeem=1&promotion_id=${item.id}`;
    }
  };

  return (
    <>
      <div className="reward">
        <div className="reward__banner"></div>
        <div className="reward__content">
          <div className="container container--500">
            <h1 className="text--center">{langData.title}</h1>
            <p className="text--center">{langData.description}</p>
            <div className="rf__trigger " style={{ position: "inherit" }}>
              <a href="#" className="filter__trigger" onClick={filterMobile}>
                Filter
              </a>
            </div>
          </div>

          <div className="container bar">
            <div className="sidebar">
              <div className="sidebar__aside">
                <span
                  className="tablet--only marr--lg filter__trigger"
                  onClick={filterMobile}>
                  <img src={Img_close} alt="" />
                </span>
                <span>{langData.label_filter}</span>
              </div>

              <div className="sidebar__row">
                <div className="sidebar__title">{langData.label_point}</div>
                <div className="form__col form__col--inline">
                  <InputNumber
                    name="min_point"
                    onChange={onChangeMinPoint}
                    placeholder="Minimum"
                    min={0}
                    max={100000}
                    defaultValue={minPoint}
                  />
                  <small className="marr--md marl--md text--grey-light">
                    to
                  </small>
                  <InputNumber
                    name="max_point"
                    onChange={onChangeMaxPoint}
                    placeholder="Maximum"
                    min={0}
                    max={100000}
                    defaultValue={maxPoint}
                  />
                </div>

                <div className="form__col form__col--inline">
                  <Button
                    type="primary"
                    onClick={() => {
                      filterTrigerPoint("desktop");
                    }}
                    className="button button--cta full-width"
                    style={{ width: "100%" }}>
                    {langData.btn_label_view}
                  </Button>
                </div>
              </div>
              <div className="sidebar__row">
                <div className="sidebar__title">{langData.label_location}</div>
                <div className="form__col form__col--inline">
                  <Select
                    defaultValue={currentLocation}
                    style={{ width: "100%" }}
                    listHeight={272}
                    placeholder={langData.placeholder_location}
                    optionFilterProp="children"
                    className="input"
                    bordered={false}
                    onChange={onChangeLocation}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }>
                    {rewards_item_location.length > 0 ? (
                      <>
                        <Option value="" key="">
                          {langData.placeholder_location}
                        </Option>
                        {rewards_item_location.map((obj, index) => {
                          return (
                            <Option value={obj.code} key={obj.code}>
                              {obj.name}
                            </Option>
                          );
                        })}
                      </>
                    ) : (
                      <Option value="" key="">
                        {langData.placeholder_location}
                      </Option>
                    )}
                  </Select>
                </div>
                <div className="sidebar__title">{langData.label_category}</div>
                <div className="form__col form__col--inline">
                  <Select
                    defaultValue={currentCategory}
                    style={{ width: "100%" }}
                    placeholder={langData.placeholder_category}
                    className="input"
                    bordered={false}
                    onChange={onChangeCategory}>
                    {filteredCategories.length > 0 ? (
                      <>
                        <Option value="" key="">
                          {langData.placeholder_category}
                        </Option>
                        {filteredCategories.map((obj, index) => {
                          return (
                            <Option
                              value={String(
                                process.env.GATSBY_ENABLE_AUTH0 === "true"
                                  ? obj.categoryId
                                  : obj.category_id
                              )}
                              key={
                                process.env.GATSBY_ENABLE_AUTH0 === "true"
                                  ? obj.categoryId
                                  : obj.category_id
                              }>
                              {obj.name}
                            </Option>
                          );
                        })}
                      </>
                    ) : (
                      <Option value="" key="">
                        {langData.placeholder_category}
                      </Option>
                    )}
                  </Select>
                </div>
              </div>
              <Button
                type="primary"
                className="button button--cta tablet--only full-width"
                onClick={() => {
                  filterTrigerPoint("mobile");
                }}>
                {langData.btn_label_view}
              </Button>
            </div>

            <div className="mainbar">
              <div className="rl__wrapper">
                {filteredRewardsData !== undefined && (
                  <>
                    {filteredRewardsData.map((obj, key) => {
                      const is_special_promotion = special_promotion.find(
                        ({ id }) => id === obj.id
                      );
                      return (
                        <>
                          {isAuth0Enabled ? (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a
                              onClick={() => navigateToRedemptionUrl(obj.id, obj)}
                              className="rl"
                              key={obj.id}>
                              <div className="rl__content reward-box-content heightfull">
                                {typeof is_special_promotion !== "undefined" ? (
                                  <div className="rl_ribbon">
                                    <div className="rl_ribbon_title">
                                      {langData.label_ribbon_special_offer}
                                    </div>
                                  </div>
                                ) : null}

                                <div className="rl__imgs">
                                  <img
                                    src={obj.image}
                                    className="full-width"
                                    alt={obj.image}
                                  />
                                </div>

                                <div className="rl__inner">
                                  <div className="rl__inner--top">
                                    <div className="rl__title">{obj.name}</div>
                                  </div>
                                  {typeof is_special_promotion !==
                                    "undefined" ? (
                                    <div className="rl__price ">
                                      <div class="rl__price_promotion_title">
                                        {langData.label_point_required}
                                      </div>
                                      <div class="rl__price_promotion_point">
                                        <b>
                                          {obj.value.toLocaleString()}{" "}
                                          {langData.label_point}
                                        </b>{" "}
                                        <del>
                                          {is_special_promotion.slashed_price.toLocaleString()}{" "}
                                          {langData.label_point}
                                        </del>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="rl__price">
                                      {langData.label_point_required}{" "}
                                      <b>
                                        {obj.value.toLocaleString()}{" "}
                                        {langData.label_point}
                                      </b>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </a>
                          ) : (
                            <a
                              onClick={() => loginwithoutAuth0(obj)}
                              className="rl"
                              key={obj.id}>
                              <div className="rl__content reward-box-content heightfull">
                                {typeof is_special_promotion !== "undefined" ? (
                                  <div className="rl_ribbon">
                                    <div className="rl_ribbon_title">
                                      {langData.label_ribbon_special_offer}
                                    </div>
                                  </div>
                                ) : null}

                                <div className="rl__imgs">
                                  <img
                                    src={obj.image}
                                    className="full-width"
                                    alt={obj.image}
                                  />
                                </div>

                                <div className="rl__inner">
                                  <div className="rl__inner--top">
                                    <div className="rl__title">{obj.name} test</div>
                                  </div>
                                  {typeof is_special_promotion !==
                                    "undefined" ? (
                                    <div className="rl__price ">
                                      <div class="rl__price_promotion_title">
                                        {langData.label_point_required}
                                      </div>
                                      <div class="rl__price_promotion_point">
                                        <b>
                                          {obj.value.toLocaleString()}{" "}
                                          {langData.label_point}
                                        </b>{" "}
                                        <del>
                                          {is_special_promotion.slashed_price.toLocaleString()}{" "}
                                          {langData.label_point}
                                        </del>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="rl__price">
                                      {langData.label_point_required}{" "}
                                      <b>
                                        {obj.value.toLocaleString()}{" "}
                                        {langData.label_point}
                                      </b>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </a>
                          )}
                        </>
                      );
                    })}
                  </>
                )}
              </div>
              {rewards.pagination?.total == 0 && (
                <>
                  <Empty
                    description="Reward item not found, please choose another filter ."
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </>
              )}
              <div id="post_paging">
                {rewards.pagination !== undefined ? (
                  <Pagination
                    hideOnSinglePage={true}
                    responsive={true}
                    defaultCurrent={rewards.pagination.currentPage}
                    current={rewards.pagination.currentPage}
                    total={rewards.pagination.total}
                    style={{ float: "right" }}
                    onChange={onChangePages}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
